import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import * as DevModules from 'devextreme-angular';

import { ModeloGridFormComponent } from './form/modelo-grid.form';
import { ModeloGridListaComponent } from './lista/modelo-grid.lista';

@NgModule({
   imports: [
      CommonModule,
      DevModules.DxBoxModule,
      DevModules.DxButtonModule,
      DevModules.DxContextMenuModule,
      DevModules.DxDataGridModule,
      DevModules.DxFormModule,
      DevModules.DxPivotGridModule,
      DevModules.DxPopupModule,
      FormsModule
   ],
   exports: [
      ModeloGridFormComponent,
      ModeloGridListaComponent
   ],
   declarations: [
      ModeloGridFormComponent,
      ModeloGridListaComponent
   ],
   entryComponents: [
      ModeloGridFormComponent,
      ModeloGridListaComponent
   ],
   providers: []
})
export class ModeloGridModule { }
